export default __webpack_public_path__ + "static/img_interviewee_dwjung@2x-25a53e864793499edcf2124e7c7cc940.png";